export enum LineEqualType {
  doubleLine = "DOUBLE_LINE",
  singleLine = "SINGLE_LINE"
}

export enum ArrowCap {
  None = "NONE",
  Start = "START",
  End = "END",
  Both = "BOTH"
}

export enum LineEqualSymbol {
  Dash = "DASH",
  Arrow = "ARROW"
}

export enum SwitcherBgColors {
  defaultBgColor = 0xdd45d0,
  pressedBgColor = 0xFFF000
}